var React = require('react');

function GalleryIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.875 1.89591V13.8401H0V0H21.875V1.89591H1.875Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.12503 17.0001V3.15991H25V17.0001H3.12503ZM15.25 14.2194H18.75V8.08928L14.0625 5.94058L9.37503 8.08928V14.2194H12.9063V10.9015H15.25V14.2194Z","fill":"white","key":1})]);
}

GalleryIcon.defaultProps = {"width":"25","height":"17","viewBox":"0 0 25 17","fill":"none"};

module.exports = GalleryIcon;

GalleryIcon.default = GalleryIcon;
